export enum Classification {
  Major = 1,
  Minor,
}
